import PropTypes from 'prop-types';
import React from 'react';
import styles from './camera.module.css';

import icFail from '../../../../img/fail.png'

const Camera = props => (

    <div className={styles['backgroud-layer']}>
        <div className={styles.body}>
            <canvas
                className={styles.canvas}
                width="180"
                height="180"
                ref={props.canvasRef}
            />
            {props.shibieStatus?
                <img className={styles["img-fail"]} src={icFail}/>
            :null}

        </div>
    </div>
);

Camera.propTypes = {
    access: PropTypes.bool,
    canvasRef: PropTypes.func.isRequired,
    capture: PropTypes.string,
    loaded: PropTypes.bool,
};

export default Camera;
